// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2SgQz","label":"styles_label__3Vwut"};